import React, { FunctionComponent, useEffect } from 'react'

import { formatDualSessionsText } from '@lyrahealth-inc/shared-app-logic/src/features/sessions/utils/dualSessionsFormatter'
import { CustomerInfo } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import styles from './clientEmail.module.scss'
import { STSTypes } from '../../../../mixpanel/mixpanelConstants'
import { track } from '../../../../mixpanel/mixpanelTracking'
import { sessionTracking } from '../../common/constants/appConstants'

type Props = {
  initialSession?: boolean
  sessionsLeft?: number
  firstName?: string
  lastName?: string
  customer?: CustomerInfo
  programDisplayName?: string
}

const ThankYou: FunctionComponent<Props> = ({
  initialSession,
  sessionsLeft,
  firstName,
  lastName,
  customer,
  programDisplayName,
}) => {
  useEffect(() => {
    if (initialSession) {
      track({ event: 'STS', properties: { type: (STSTypes as any).STS_INITIAL } })
    }
  })

  return (
    <span>
      <h1 className={styles.title}>Thank you!</h1>
      {customer?.display_visits_per_issue_per_year_by_program ? (
        <div>
          <p className={styles.success}>
            Your payment was successfully submitted. As a reminder, your client,{' '}
            <span className={styles.capitalize}>{firstName}</span> <span className={styles.capitalize}>{lastName}</span>{' '}
            has session costs covered for a set number of sessions as part of their Lyra benefit
          </p>
          <p className={styles['remaining-sessions']}>
            Please note that <span className={styles.capitalize}>{firstName}</span> has{' '}
            {formatDualSessionsText(customer?.display_visits_per_issue_per_year_by_program)}. Issues determined by you
            and your client.
          </p>
          <p className='paragraph-small'>
            For any questions, please contact <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a>
          </p>
        </div>
      ) : customer?.display_visits_per_issue_per_year ? (
        <div>
          <p className={styles.success}>
            Your payment was successfully submitted. As a reminder, your client,{' '}
            <span className={styles.capitalize}>{firstName}</span> <span className={styles.capitalize}>{lastName}</span>{' '}
            has session costs covered for a set number of sessions as part of their Lyra benefit
          </p>
          <p className={styles['remaining-sessions']}>
            Please note that <span className={styles.capitalize}>{firstName}</span> has{' '}
            {customer?.display_visits_per_issue_per_year} visits per issue per year. Issues determined by you and your
            client.
          </p>
          <p className='paragraph-small'>
            For any questions, please contact <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a>
          </p>
        </div>
      ) : initialSession ? (
        <div>
          <p className={styles.success}>
            Your payment was successfully submitted. As a reminder, your client,{' '}
            <span className={styles.capitalize}>{firstName}</span> <span className={styles.capitalize}>{lastName}</span>{' '}
            has session costs covered for a set number of sessions as part of their Lyra benefit
          </p>
          <p className={styles['remaining-sessions']}>
            Please note that <span className={styles.capitalize}>{firstName}</span> has {sessionsLeft}{' '}
            {programDisplayName && `${programDisplayName} `}sessions remaining.
          </p>
          <p className='paragraph-small'>
            We’ll let you both know when there are only {sessionTracking.WARNING_THRESHOLD}{' '}
            {programDisplayName && `${programDisplayName} `}sessions left so you and {firstName} can start planning to
            complete treatment or discussing longer term care. For any questions, please contact{' '}
            <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a>
          </p>
        </div>
      ) : (
        <h2 className={styles.success}>Your payment was successfully submitted.</h2>
      )}
    </span>
  )
}

export default ThankYou
